import { I18n } from '@calendly/i18n'
import { useCallback } from 'react'
import { useDispatch } from 'react-redux'

import { redirectToAuthorizeUrl } from 'actions/omniauth'
import { PageContent } from 'components/page_elements'
import { useBooleanState } from 'hooks/useBooleanState'

import AzureLogo from './azure-logo'
import CalendlyLogo from './calendly-logo'
import {
  Container,
  LogoContainer,
  ConnectLogo,
  PlusIcon,
  Description,
  ConnectButton
} from './elements'

export const MicrosoftAdminConsent = () => {
  const dispatch = useDispatch()
  const [isAuthorizing, startAuthorize] = useBooleanState(false)

  const authorize = useCallback(
    () => {
      startAuthorize()
      dispatch(redirectToAuthorizeUrl('/users/auth/azure2_admin_consent'))
    },
    [startAuthorize, dispatch]
  )

  return (
    <PageContent>
      <Container>
        <LogoContainer>
          <ConnectLogo src={CalendlyLogo} />
          <PlusIcon />
          <ConnectLogo src={AzureLogo} />
        </LogoContainer>
        <Description>
          {I18n.t('publisher.integrations.microsoft_admin_consent.description')}
        </Description>
        <ConnectButton
          onClick={authorize}
          loading={isAuthorizing}
        >
          {I18n.t('publisher.integrations.microsoft_admin_consent.authorize_button')}
        </ConnectButton>
      </Container>
    </PageContent>
  )
}
